export function isNavigableAddress(address: string | undefined): boolean {
  const trimmed = address?.trim();
  return Boolean(trimmed && trimmed !== '—');
}

/** 在 Google 网页地图中打开地址定位 */
export function openGoogleMapsNavigation(address: string): void {
  const trimmed = address.trim();
  if (!isNavigableAddress(trimmed)) return;

  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(trimmed)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
